import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import dayjs from 'dayjs';

import { CommonsProvider, PortalNameType } from '@zeta-commons';
import { CoreThemeProvider, MotionLazy, ProgressBar, SettingsProvider, SnackbarProvider, useLocales } from '@zeta-core';
import { AuthProvider } from '../app/auth/jwt';

import Router from './routes/sections';

const queryClient = new QueryClient();

const AppProvider = () => {
  const { currentLang } = useLocales();
  dayjs.locale(currentLang?.value || 'en');

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={currentLang?.value}>
      <SettingsProvider
        defaultSettings={{
          themeMode: 'dark', // 'light' | 'dark'
          themeContrast: 'default', // 'default' | 'bold'
          themeLayout: 'horizontal', // 'vertical' | 'horizontal' | 'mini'
          themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
          themeStretch: false,
        }}
      >
        <CoreThemeProvider authThemeMode="dark">
          <MotionLazy>
            <SnackbarProvider>
              <ProgressBar />
              <CommonsProvider config={{ portal: PortalNameType.ADVISOR }}>
                <Router />
              </CommonsProvider>
            </SnackbarProvider>
          </MotionLazy>
        </CoreThemeProvider>
      </SettingsProvider>
    </LocalizationProvider>
  );
};

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppProvider />
      </AuthProvider>
      <ReactQueryDevtools buttonPosition="bottom-left" />
    </QueryClientProvider>
  );
}
